"use client";
import { Box } from "@chakra-ui/react";
import { Balancer } from "react-wrap-balancer";
import SimpleIntro from "@/components/simpleIntro";
import { Text } from "@/elements";
import { INTRO_CONSTANTS } from "./constants";

const IntroComponent = () => {
  return (
    <Box maxW={"4xl"} mx={"auto"}>
      <SimpleIntro {...INTRO_CONSTANTS} />
      <Balancer>
        <Text variant={"body1"} color="text.100" mt={4} textAlign={"center"}>
          {INTRO_CONSTANTS.concText}
        </Text>
      </Balancer>
    </Box>
  );
};

export default IntroComponent;
